import { observable, extendObservable, computed, action, autorun } from 'mobx';
import storage from 'lib/localStorage';

export default class KasumikalkStore {
  @observable numbers = {
    wages: 0,
    rent: 0,
    kba: 0,
    versant: 0,
    halm: 0
  };

  constructor() {
    this.load();
    this.persist();
  }

  @computed get toJson() {
    return this.numbers;
  }

  @computed get wages() { return this.numbers.wages; }
  @computed get rent() { return this.numbers.rent; }
  @computed get kba() { return this.numbers.kba; }
  @computed get versant() { return this.numbers.versant; }
  @computed get halm() { return this.numbers.halm; }

  @computed get totalExpenses() {
    return this.wages + this.rent;
  }

  @computed get totalIncome() {
    return this.kba + this.versant + this.halm;
  }

  @action updateWages = wage => this.numbers.wages = parseInt(wage);
  @action updateRent = rent => this.numbers.rent = parseInt(rent);
  @action updateKBA = kba => this.numbers.kba = parseInt(kba);
  @action updateVersant = versant => this.numbers.versant= parseInt(versant);
  @action updateHalm = halm => this.numbers.halm = parseInt(halm);

  @action load() {
    const stored = storage.get('ProfitStore') || {};
    Object.keys(stored).forEach(key => this.numbers[key] = stored[key]);
  }
  persist() {
    autorun(() => {
      storage.set('ProfitStore', this.toJson)
    })
  }
}



// WEBPACK FOOTER //
// ./src/views/Kasumikalk/KasumikalkStore.js